export function assertUnreachable(x: never): never {
  throw new Error(`Didn't expect to get ${x} here`);
}

// it turns an object with arbitrary levels of nested objects into a flat object
// with string keys representing the previously nested layers
export function flattenObj(obj: Record<string, any>, prefix: string = "") {
  return Object.keys(obj).reduce((acc: Record<string, any>, key) => {
    const pre = prefix.length ? prefix + "." : "";
    if (typeof obj[key] === "object") {
      Object.assign(acc, flattenObj(obj[key], pre + key));
    } else {
      acc[pre + key] = obj[key];
    }
    return acc;
  }, {});
}

// this is a recursive function that merges two objects together and returns a new object
// if any keys are arrays, it will concatenate the arrays
// if any keys are objects, it will recursively merge the objects
export function mergeObjects(obj1: { [x: string]: any }, obj2: { [x: string]: any }) {
  const mergedObj = { ...obj1, ...obj2 };

  Object.keys(mergedObj).forEach((key) => {
    if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
      mergedObj[key] = [...obj1[key], ...obj2[key]];
    } else if (typeof obj1[key] === "object" && typeof obj2[key] === "object") {
      mergedObj[key] = mergeObjects(obj1[key], obj2[key]);
    }
  });

  return mergedObj;
}

export function someTruthyProperty(object: Record<string, boolean>): boolean {
  const flatObj = flattenObj(object);
  return Object.values(flatObj).some((val) => val);
}

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}
